module.exports = __webpack_public_path__ + "static/media/banksucess.9d39972b.svg";